import { rackSizeOptions } from "@/common/const";
import quoteCreationTypeOptions from "@/common/const/quote/quoteCreationTypes.const";
import { ColumnsStrategy, PriceType } from "@/common/types";
import { QuoteActions } from "@/components";
import QuoteCreationTypeTag from "@/components/Quotes/QuoteCreationType/QuoteCreationTypeTag";
import PickQuoteLineElement from "@/components/Quotes/SingleQuoteResults/PickQuoteLineElement";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  FilterSelect,
  OptionsCell,
} from "@/components/TableComponents";
import RangeFilter from "@/components/TableComponents/Head/RangeFilter";
import SortComponent from "@/components/TableComponents/Head/SortComponent";

const rackAndSpaceQuoteResultsStrategy: ColumnsStrategy[] = [
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => <PickQuoteLineElement data={record} />,

    headerClassName: "!bg-white pb-3",
  },

  {
    label: <DefaultHeadColumns text="Quote Line Id" key={"Quote Line Id"} />,
    name: "id",
    render: (value: string, record: any) => (
      <DefaultTextColumn className="py-0" text={value} key={record.id} />
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: (
      <FilterSelect
        fieldName="filters-rackSize"
        values={rackSizeOptions}
        key="Rack Size"
      />
    ),
    name: "price",
    render: (value: PriceType, record: any) => (
      <OptionsCell
        value={value.rackSize?.toString() || "No data"}
        options={rackSizeOptions}
        key={`${record.id}-${value.id}-${value.rackSize}`}
      />
    ),
    headerClassName: "!bg-white !pb-[22px]",
  },
  // {
  //   label: (
  //     <RangeFilter
  //       fieldName="filters-spaceSize"
  //       min={0}
  //       max={100}
  //       title="Space Size"
  //       key={"spaceSize"}
  //     />
  //   ),
  //   name: "price",
  //   render: (value: any, record: any) => (
  //     <div key={record.id}>{value.spaceSize}</div>
  //   ),
  //   headerClassName: "!bg-white !pb-6",
  // },
  {
    label: <DefaultHeadColumns text="Currency" key={"Currency"} />,
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.targetCurrency}</div>
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: (
      <RangeFilter
        fieldName="filters-targetOTC"
        title="OTC"
        max={100000}
        min={0}
      />
    ),
    name: "price",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          className="py-0 text-primary"
          text={
            value.targetOTC === null
              ? "0"
              : Number.parseFloat(value.targetOTC).toFixed(2)
          }
          key={[value.id, record.id, value.targetOTC].join("-")}
        />
      );
    },
    headerClassName: "!bg-white !pb-[30px]",
  },
  {
    label: (
      <RangeFilter
        fieldName="filters-targetMRC"
        title="MRC"
        max={100000}
        min={0}
      />
    ),
    name: "price",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          className="py-0 text-primary"
          text={
            value.targetMRC === null
              ? "0"
              : Number.parseFloat(value.targetMRC).toFixed(2)
          }
          key={[value.id, record.id, value.targetMRC].join("-")}
        />
      );
    },
    headerClassName: "!bg-white !pb-[30px]",
  },
  {
    label: (
      <RangeFilter
        fieldName="filters-quantity"
        min={1}
        max={500}
        title="Quantity"
        key={"Quantity"}
      />
    ),
    name: "price",
    render: (value: PriceType, record: any) => (
      <div key={record.id}>{value.quantity?.toString() || "No data"}</div>
    ),
    headerClassName: "!bg-white !pb-[30px]",
  },
  {
    label: (
      <SortComponent
        childKey="power"
        title="Power"
        tooltipVariants={["Form 1kW up to 20 kW", "From 20kW to 1kW"]}
      />
    ),
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.power}</div>
    ),
    headerClassName: "!bg-white !pb-[18px]",
  },
  {
    label: (
      <RangeFilter
        fieldName="filters-contractTerm"
        title="Contract Terms"
        min={1}
        max={60}
      />
    ),
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.contractTerm}</div>
    ),
    headerClassName: "!bg-white !pb-[30px]",
  },
  {
    label: (
      <FilterSelect
        fieldName="filters-quoteLineType"
        values={quoteCreationTypeOptions}
      />
    ),
    name: "quoteType",
    render: (value: "Firm" | "Budgetary", record: any) => (
      <QuoteCreationTypeTag quoteCreationType={value} key={record.id} />
    ),
    headerClassName: "!bg-white !pb-[22px]",
  },
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => <QuoteActions quoteLine={record} />,
    headerClassName: "!bg-white pb-3",
  },
];
const rackAndSpaceQuoteResultsStrategyWithoutFilters: ColumnsStrategy[] = [
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => <PickQuoteLineElement data={record} />,

    headerClassName: "!bg-white pb-3",
  },
  {
    label: <DefaultHeadColumns text="Quote Line Id" key={"Quote Line Id"} />,
    name: "id",
    render: (value: string, record: any) => <div key={record.id}>{value}</div>,
    headerClassName: "!bg-white pb-3",
  },
  {
    label: <DefaultHeadColumns text="Rack Size" key={"Rack size"} />,
    name: "price",
    render: (value: PriceType, record: any) => (
      <OptionsCell
        value={value.rackSize?.toString() || "No data"}
        options={rackSizeOptions}
        key={`${record.id}-${value.id}-${value.rackSize}`}
      />
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="Space Size" key={"Space size"} />,
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.spaceSize}</div>
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="Currency" key={"Currency"} />,
    name: "price",
    render: (value: any, record: any) => (
      <DefaultTextColumn
        text={value.targetCurrency}
        key={value.currency + record.id}
        className="py-0"
      />
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="OTC" key={"OTC"} />,
    name: "price",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          className="py-0 text-primary"
          text={
            value.targetMRC === null
              ? "0"
              : Number.parseFloat(value.targetOTC).toFixed(2)
          }
          key={[value.id, record.id, value.targetOTC].join("-")}
        />
      );
    },
    headerClassName: "!bg-white !pb-3 ",
  },
  {
    label: <DefaultHeadColumns text="MRC" key={"MRC"} />,
    name: "price",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          className="py-0 text-primary"
          text={
            value.targetMRC === null
              ? "0"
              : Number.parseFloat(value.targetMRC).toFixed(2)
          }
          key={[value.id, record.id, value.targetMRC].join("-")}
        />
      );
    },
    headerClassName: "!bg-white !pb-3 ",
  },
  {
    label: <DefaultHeadColumns text="Quantity" key={"quantity"} />,
    name: "price",
    render: (value: PriceType, record: any) => (
      <div key={record.id}>{value.quantity?.toString() || "No data"}</div>
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="Power" key={"Power"} />,
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.power}</div>
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="Contract Terms" key={"Contract Terms"} />,
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.contractTerm}</div>
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="Quote Type" key={"Quote Type"} />,
    name: "quoteType",
    render: (value: "Firm" | "Budgetary", record: any) => (
      <QuoteCreationTypeTag quoteCreationType={value} key={record.id} />
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => <QuoteActions quoteLine={record} />,
    headerClassName: "!bg-white pb-3",
  },
];
export {
  rackAndSpaceQuoteResultsStrategy,
  rackAndSpaceQuoteResultsStrategyWithoutFilters,
};
